/**
 * Event visibility — safe on client and server.
 */

export const EVENT_VISIBILITY_PUBLIC = "public" as const
export const EVENT_VISIBILITY_PRIVATE = "private" as const
export const EVENT_VISIBILITY_INVITE_ONLY = "invite_only" as const
/** Anyone with the link + valid `?share=` token can view; signed-in participants / timeline saves may view without the token. */
export const EVENT_VISIBILITY_LINK_ONLY = "link_only" as const

export type EventVisibility =
  | typeof EVENT_VISIBILITY_PUBLIC
  | typeof EVENT_VISIBILITY_PRIVATE
  | typeof EVENT_VISIBILITY_INVITE_ONLY
  | typeof EVENT_VISIBILITY_LINK_ONLY

const ALLOWED = new Set<string>([
  EVENT_VISIBILITY_PUBLIC,
  EVENT_VISIBILITY_PRIVATE,
  EVENT_VISIBILITY_INVITE_ONLY,
  EVENT_VISIBILITY_LINK_ONLY,
])

export function parseEventVisibility(
  raw: string | null | undefined,
): EventVisibility {
  if (raw != null && ALLOWED.has(raw)) {
    return raw as EventVisibility
  }
  return EVENT_VISIBILITY_PUBLIC
}

/** Short neutral label for settings / host summary chips (not a time status). */
export function formatEventVisibilityLabel(
  raw: string | null | undefined,
): string {
  switch (parseEventVisibility(raw)) {
    case EVENT_VISIBILITY_PUBLIC:
      return "Shared"
    case EVENT_VISIBILITY_PRIVATE:
      return "Private"
    case EVENT_VISIBILITY_INVITE_ONLY:
      return "Invite only"
    case EVENT_VISIBILITY_LINK_ONLY:
      return "Link access"
    default:
      return "Shared"
  }
}

/** Shown on anonymous / discovery-style lists (GET /api/events). */
export function isPublicListVisibility(
  raw: string | null | undefined,
): boolean {
  return parseEventVisibility(raw) === EVENT_VISIBILITY_PUBLIC
}
